const styleVariables = {
	primaryColor: '#1A2B48',
	secondaryColor: '#2bcdca',
	greyColor: '#8799B4',
	greyLightColor: '#E3E8F0',
	sliceColors: {
		lightMode: [
			'#2ABDBB',
			'#86D9D8', // Real estate
			'#559ba6',
			'#2C6172',
			'#1C4159',
			'#1A2B48', // Private credit
			'#00338A',
			'#084F97',
			'#1375A8',
			'#26B7C6',
			'#2B70E7',
			'#2c4c87',
			'#51627E',
			'#3d9bba',
			'#2FD8D5',
			'#6D9DF1',
		],
		darkMode: [
			'#BA4AFF',
			'#1C70FF',
			'#73FFC4',
			'#FFFFFF',
			'#FF9F0F',
			'#00D1FF',
			'#FF77FA',
			'#FFEC42',
			'#4CC8C6',
			'#FFF4BC',
			'#915EFF',
			'#30FFF3',
			'#00A8DD',
			'#FF5A9F',
			'#E1E1E1',
		],
	},
};

export default styleVariables;
